import { render, staticRenderFns } from "./EditPostDialog.vue?vue&type=template&id=c7608ae2&scoped=true"
import script from "./EditPostDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPostDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditPostDialog.vue?vue&type=style&index=0&id=c7608ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7608ae2",
  null
  
)

export default component.exports